import GeneralHelpers from '../GeneralHelpers/index';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers/index';
// https://github.com/sparksuite/simple-html-invoice-template
// https://github.com/rimiti/html-invoice-template
// https://github.com/greywillfade/freeagent-invoice
// https://github.com/AlexAltea/invoice

const getLineItem = ({ description, amount, currencySymbol }) => `
        <tr class="item">
            <td>
                ${description || ''}
            </td>
            
            <td>
                ${CurrencyHelpers.centsToDollars(amount, { symbol: currencySymbol })}
            </td>
        </tr>
    `;

const getLineItems = ({ lineItems, currencySymbol }) => {
  let html = '';
  if (lineItems && lineItems.length > 0 && lineItems.forEach) {
    lineItems.forEach(item => {
      let text = getLineItem({
        description: item.description,
        amount: item.amount && item.amount.replace ? item.amount.replace('.', '').replace(',', '') : item.amount,
        currencySymbol,
      });
      html = html.concat(text);
    });
  }

  return html;
};

const styles = `        
<style>
.invoice-box {
    max-width: 100%;
    min-width: 300px;
    margin: auto;
    padding: 30px;
    background: #fff;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, .15);
    font-size: 14px;
    line-height: 24px;
    font-family: 'Open Sans', 'Helvetica', Helvetica, Arial, sans-serif;
    color: #555;
}

.invoice-box table {
    width: 100%;
    line-height: inherit;
    text-align: left;
}

.paid {
    color: #6ab04c;
    font-size: 50px;
}

.invoice-box table td {
    padding: 5px;
    vertical-align: top;
}

.invoice-box table tr td:nth-child(2) {
    text-align: right;
}

.invoice-box table tr.top table td {
    padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
    font-size: 42px;
    line-height: 45px;
    color: #333;
}

.invoice-box table tr.information table td {
    padding-bottom: 40px;
}

.invoice-box table tr.heading td {
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
}

.invoice-box table tr.details td {
    padding-bottom: 20px;
}

.invoice-box table tr.item td{
    border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
    border-bottom: none;
}

.invoice-box table tr.total td:nth-child(2) {
    border-top: 2px solid #eee;
    font-weight: bold;
}

@media only screen and (max-width: 600px) {
    .invoice-box table tr.top table td {
        width: 100%;
        display: block;
        text-align: center;
    }
    
    .invoice-box table tr.information table td {
        width: 100%;
        display: block;
        text-align: center;
    }
}

/** RTL **/
.rtl {
    direction: rtl;
    font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
}

.rtl table {
    text-align: right;
}

.rtl table tr td:nth-child(2) {
    text-align: left;
}
</style>`;

const getPricingSection = ({ invoice, currencySymbol }) => {
  if (!invoice.finalPaymentAmount) {
    return '';
  }

  return `
    <tr class="heading">
    <td>
        SERVICES PROVIDED
    </td>
    
    <td>
        PRICING
    </td>
    </tr>
    
    ${getLineItems({
    lineItems: invoice.lineItems,
    currencySymbol,
  })}
    <tr>
    <td></td>
    
    <td>
       ${
  invoice.discountAmount
    ? `Discount: ${CurrencyHelpers.centsToDollars(invoice.discountAmount, { symbol: currencySymbol })}`
    : ''
}
    </td>
    </tr>

    <tr>
    <td></td>
    <td>
       ${
  invoice.subtotalAfterDiscount
    ? `Subtotal: ${CurrencyHelpers.centsToDollars(invoice.subtotalAfterDiscount, { symbol: currencySymbol })}`
    : ''
}
    </td>
    </tr>

    <tr>
    <td></td>
    <td>
       ${
  invoice.taxAmount
    ? `Sales Tax: ${CurrencyHelpers.centsToDollars(invoice.taxAmount, { symbol: currencySymbol })}`
    : ''
}
    </td>
    </tr>
    
    
    <tr class="total">
    <td></td>
    
    <td>
       Total: ${CurrencyHelpers.centsToDollars(invoice.finalPaymentAmount, { symbol: currencySymbol })}
    </td>
    </tr>
    `;
};

const getMemo = ({ memo }) => {
  // if no memo data passed, return nothing
  if (!memo) {
    return '';
  }

  return `
    <tr>
    <td style="font-weight: 600;">
        MEMO:
    </td>
    <tr class="item">
            <td>
                ${memo}
            </td>
        </tr>
    </tr>
    `;
};

const getTop = ({ organization, invoice }) => `
    <tr class="top">
    <td colspan="2">
        <table>
            <tr>
                <td class="title">
                ${organization.image ? `<img src="${organization.image}" style="max-width:250px;">` : '<span />'} 
                </td>
                <td>
                <span class="invoice-label">#</span>: ${invoice.number || ''}<br>
                    <span class="invoice-label">Created</span>: ${GeneralHelpers.formatShortDate(invoice.createdAt)}<br>
                    <span class="invoice-label">Due</span>: ${GeneralHelpers.formatShortDate(invoice.due)}
                </td>
            </tr>
        </table>
    </td>
</tr>
    `;

const getHead = () => `
        <head>
            <meta charset="utf-8">
            ${styles}
        </head>
    `;

const getInformation = ({ organization, invoice }) => `
        <tr class="information">
            <td colspan="2">
                <table>
                    <tr>
                        <td>
                            ${organization.title || ''}<br>
                            ${organization.street1 || ''}<br>
                            ${organization.city || ''}${' '}, ${organization.state || ''} ${organization.zip || ''}
                        </td>
                        
                        <td>
                            ${invoice.client.firstName || ''} ${' '} ${invoice.client.lastName || ''}<br>
                            ${invoice.client.email || ''}<br>
                            ${invoice.client.street1 || ''}<br>
                            ${invoice.client.city || ''}, ${invoice.client.state || ''}
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    `;

const getHtmlInvoice = ({ organization, invoice }) => {
  console.log('getHtmlInvoice invoice');
  console.log(invoice);

  let currencySymbol = CurrencyHelpers.getCurrencySymbol(invoice.currency);
  //
  //
  //
  // ${getPricingSection({ invoice, currencySymbol })}
  //
  return `
    <!doctype html>
    <html>
    ${getHead()}
    
    <body>
        <div class="invoice-box">
            <table cellpadding="0" cellspacing="0">

            ${getTop({ organization, invoice })}

            ${getInformation({ organization, invoice })}
                
            ${getPricingSection({ invoice, currencySymbol })}

            ${getMemo({ memo: invoice.memo })}
            

            </table>
            ${invoice.status === 'PAID' ? '<h1 class="paid">PAID</h1>' : ''}
        </div>
    </body>
    </html>
    `;
};

export default getHtmlInvoice;



// WEBPACK FOOTER //
// ./src/lib/helpers/PDFHelpers/getHtmlInvoice.js